import { Button } from "@mantine/core";
import saveAs from "file-saver";
import { useState } from "react";
import api from "../../../../api";
import { useToast } from "../../../../mantine/notifications/useToast";
import { postDataAndPollResponse } from "../../../../utils/api-utils";
import { b64toBlob } from "../../../../utils/files/b64toBlob";

export interface DownloadButtonProps {
  downloadRequestUrl: string;
  downloadRequestOptions: Record<string, string | number | Array<number>>;
  downloadUrlFunc: (taskId: string) => string;
  disabled?: boolean;
}

function DownloadButton({
  downloadRequestUrl,
  downloadRequestOptions,
  downloadUrlFunc,
  disabled
}: DownloadButtonProps) {
  const { showToast, showErrorToast } = useToast();
  const [isDownloading, setIsDownloading] = useState(false);

  function handleClickDownload() {
    setIsDownloading(true);

    postDataAndPollResponse(downloadRequestUrl, downloadRequestOptions)
      .then(({ taskIds }) => {
        if (taskIds) {
          downloadFile(taskIds[0]);
        } else {
          showErrorToast({ response: { status: 500 } });

          setIsDownloading(false);
        }
      })
      .catch((errorResponse) => {
        showErrorToast(errorResponse);
        setIsDownloading(false);
      });
  }

  async function downloadFile(taskId: string) {
    const response = await api.get(downloadUrlFunc(taskId));

    if (response.data.warnings.length > 0) {
      showToast({
        type: "warning",
        message: response.data.warnings.join("<br/><br/>"),
        autoClose: 10000
      });
    }

    const contentTypeHeader = response.headers["content-type"];
    const contentType =
      typeof contentTypeHeader === "string" ? contentTypeHeader : "";
    const blob = b64toBlob(response.data.encodedFileData, contentType);

    saveAs(blob, response.data.fileName);
    setIsDownloading(false);
  }

  return (
    <Button
      color="primary"
      disabled={disabled}
      loading={isDownloading}
      onClick={handleClickDownload}
    >
      Herunterladen
    </Button>
  );
}

export { DownloadButton };
